import {ProposedService} from '../../../server/routes/availability/types';
import {ANY_EMPLOYEE} from '../../store/slices/constants';
import {formatStartTime, minutesFromMidnight} from '../../utils/time';

// passed on to checkout so it can attribute the order (see setOrderAttributionCookie)
const FORWARDED_PARAMS = ['utm_source', 'utm_medium'];

const removeServiceSuffix = (serviceId: string) => {
  return Number(serviceId.replace(/TP|TR/, ''));
};

type CheckoutUriProps = {
  proposedServices: ProposedService[];
  venueId: string | null;
  date: string | null;
  time: string | null;
  isAvailableDay: boolean;
};
export const canNavigateToCheckout = ({
  proposedServices,
  venueId,
  date,
  time,
  isAvailableDay,
}: CheckoutUriProps) => {
  if (
    !proposedServices.length ||
    !venueId ||
    !date ||
    !time ||
    !isAvailableDay
  ) {
    return false;
  }
  return true;
};

export const generateCheckoutUri = ({
  proposedServices,
  venueId,
  date,
  time,
  employeeId,
  isAvailableDay,
}: CheckoutUriProps & {employeeId: number | typeof ANY_EMPLOYEE}) => {
  const canUserNavigateToCheckout = canNavigateToCheckout({
    proposedServices,
    venueId,
    date,
    time,
    isAvailableDay,
  });

  if (!canUserNavigateToCheckout) {
    return;
  }

  const offers = proposedServices.map((service, index) => {
    const skus = service.optionIds.map((option) => {
      return {
        skuId: Number(option),
      };
    });

    const offer = {
      offerId: removeServiceSuffix(service.menuItemId),
      fulfillment: 'APPOINTMENT',
      skus,
      employeeId: service.employeeId,
    };

    if (employeeId !== ANY_EMPLOYEE && index === 0) {
      return {...offer, employeeId};
    }
    return offer;
  });

  const searchParams = new URLSearchParams();

  searchParams.set('venueId', venueId as string);
  searchParams.set('offers', JSON.stringify(offers));
  searchParams.set('date', date as string);

  const formattedTime = formatStartTime(time as string);
  const timeInMinutes = String(minutesFromMidnight(formattedTime));
  searchParams.set('time', timeInMinutes);

  const pageParams = new URLSearchParams(window.location.search);
  FORWARDED_PARAMS.forEach((name) => {
    const value = pageParams.get(name);
    if (value) {
      searchParams.set(name, value);
    }
  });

  return searchParams.toString();
};
